import { apiRequest } from '@/utils/api-request';

export const getAllOrganizations = async () => {
  const response = await apiRequest({
    url: '/organizations',
    target: 'platform',
    method: 'GET',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to get all organizations' };
  }

  return response;
};
